import { SectionHeading } from '@/components/InvoiceReportDetailDrawer/parts/SectionHeading';
import { TransactionsDetail } from '@/components/InvoiceReportDetailDrawer/TransactionsDetail';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';

type TransactionsDetailSectionProps = {
  reportId: string;
  /** Column dataIndex values to exclude from the transactions table */
  excludeColumns?: string[];
  initialOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

export const TransactionsDetailSection: FC<TransactionsDetailSectionProps> =
  memo(({ reportId, excludeColumns, initialOpen, onToggle }) => {
    const { t } = useTranslation();

    return (
      <SectionHeading
        initialOpen={initialOpen}
        title={t('invoice_reports.transactions.title')}
        onToggle={onToggle}
      >
        <TransactionsDetail
          reportId={reportId}
          excludeColumns={excludeColumns}
        />
      </SectionHeading>
    );
  });
TransactionsDetailSection.displayName =
  'AdminInvoiceReportDetailTransactionsDetailSection';
